
import Foundation from 'foundation-sites';
import ga4 from '../lib/ga-helper'

$(() => {
	const $messageModalElement = $('#messageModal'),
		$messageModal = new Foundation.Reveal($messageModalElement)

  Foundation.Abide.defaults.validators['required_if_selected'] =
    function($el, required, parent) {
      let $if = $el.attr('required_if_selected');
			const $targetErrorMessageElement = $el.parent().parent().parent().find('.form-error')
      if ($($if).is(':checked')) {
        let error = ($el.val() == '')
        if ($el.attr('type') == 'radio' || $el.attr('type') == 'checkbox') {
          $if = 'input[name="' + $el.attr('name') + '"]';
          error = !$($if).is(':checked')
        }
        if (error) {
         $targetErrorMessageElement.show()
        } else {
         $targetErrorMessageElement.hide()
        }
        return !error
      }
     	$targetErrorMessageElement.hide()
      return true
    };
    $('input[name="callback"]').on('click',function() {
      const $this = $(this)
      let border = '1px solid #ffffff;'
      if ($this.val() == 'yes') {
        $('.showMe').show()
        border = 'none'
        $this.parent().parent().parent().removeClass('showBorder')
      } else {
        $('.showMe').hide()
        $this.parent().parent().parent().addClass('showBorder')
      }
      $('.contact-container').matchHeight({property: 'height'})
    })
    $(".contact-form").on("submit", function() {
      $('.contact-container').matchHeight({property: 'height'})
    })
    new Foundation.Abide($('#contact-page-form'));

		if ($('form#contact-page-form').hasClass("contact-form")) {
			grecaptcha.ready(function() {
				grecaptcha.execute('6LfnK48UAAAAAHI21G_zmOWYDTv0n1VABrlq8MkJ', {
					action: 'contactpage'
				})
				.then(function(token) {
					$('.js-recaptcha').val(token);
				});
			})
		}
		$('#contact-page-form').on('formvalid.zf.abide', function() {
			const data = $(this).serialize(),
				url = $(this).attr('action'),
				method = $(this).attr('method'),
				submit = $(this).find('.submit')

			submit.prop('disabled', true)
			submit.val('Sending...')
			$.ajax({
				type: 'POST',
				url: window.location.pathname + '/verify_recaptcha',
				data: data,
				dataType: 'json'
			})
			.done(function(msg) {
				if (typeof(msg.success) != 'undefined' && msg.success == true) {
					$.ajax({
						type: method,
						url: url,
						data: data,
						dataType: 'json',
					})
					.done(function(msg) {
						$messageModalElement.find('.content').html(msg.message)
						$messageModal.open()
						$('#contact-page-form').trigger("reset")
						ga4.trackEvnt('contact_us_form', {'conversion_type': 'submit'})
					})
					.fail(function() {
						$messageModalElement.find('.content').html('Sorry, an error has occurred and we\'re unable ' + 'to send this request. Please try again.');
						$messageModal.open()
					})
					.always(function() {
						submit.prop('disabled', false);
						submit.val('Send');
						grecaptcha.execute('6LfnK48UAAAAAHI21G_zmOWYDTv0n1VABrlq8MkJ', {
							action: 'contactpage'
						})
						.then(function(token) {
							$('.js-recaptcha').val(token);
						});
					});
				} else {
					$messageModalElement.find('.content').html('Sorry, an error has occurred and we\'re unable ' + 'to send this request. Please try again.');
					$messageModal.open()
				}
			});
		}).on('submit', function(ev) {
			ev.preventDefault()
		})

	const $contentTriggers = $('.js-content-trigger'),
		$resultsContent = $('.js-results-content'),
		$resultsTitle = $('.js-results-title'),
		$waiterFilterButton = $('.js-waiver-filter'),
		$waiterResultsCallout = $('.js-waiter-results-callout'),
		$contactTabs = $('#js-contact-tabs')

	if ($contentTriggers.length) {
		$contentTriggers.on('click', function() {
			$waiterFilterButton.trigger('click').text($(this).text())
			$resultsTitle.fadeIn()
			$contactTabs.slideUp(350)

			if ($waiterResultsCallout.length) {
				const $calloutButton = $waiterResultsCallout.find('.js-waiter-results-callout__button')
				$waiterResultsCallout.slideDown()

				$calloutButton.on('click', function() {
					$waiterResultsCallout.slideUp(230, function(){
						setTimeout(function(){
							$contactTabs.slideDown(350)
						}, 350)
					})
				})
			}
			
 			const contentTargetId = $(this).data('contentTarget'),
				$targetContentElement = $(`#${contentTargetId}`)

			$resultsContent.each((id, el) => {
				const $accordion = $(el)
				if ($accordion.attr('id') != contentTargetId) {
					$accordion.slideUp().removeClass('active')
				}
			})
			if ($targetContentElement.hasClass('active') == false) {
				$targetContentElement.slideDown().addClass('active')
			}
		})
	}

	const $memberConsultantCheckbox	=	$('#js-member-consultant-checkbox'),
		$employerConsultantCheckbox =	$('#js-employer-consultant-checkbox'),
		$memberConsultantPanel	=	$('#js-member-consultant-panel'),
		$employerConsultantPanel = $('#js-employer-consultant-panel'),
		$stateDropdownTrigger = $employerConsultantPanel.find('#js-state-dropdown-trigger'),
		$stateFilterButtons = $employerConsultantPanel.find('.js-state-filter-btn'),
		$consultantsByState = $employerConsultantPanel.find('.js-consultants-by-state')

	if ($memberConsultantCheckbox.length
		&& $memberConsultantPanel.length
		&& $employerConsultantCheckbox.length
		&& $employerConsultantPanel.length
	) {
		$memberConsultantCheckbox.on('click', () => {
			$employerConsultantCheckbox.removeClass('r_on').addClass('r_off').find('input').prop('checked', false)
			$memberConsultantCheckbox.addClass('r_on').removeClass('r_off').find('input').prop('checked', true)
			$employerConsultantPanel.fadeOut(300, function(){
				$memberConsultantPanel.fadeIn(300)
			})
		})
		$employerConsultantCheckbox.on('click', () => {
			$memberConsultantCheckbox.removeClass('r_on').addClass('r_off').find('input').prop('checked', false)
			$employerConsultantCheckbox.addClass('r_on').removeClass('r_off').find('input').prop('checked', true)
			$memberConsultantPanel.fadeOut(300, function(){
				$employerConsultantPanel.fadeIn(300)
			})
		})

		if ($stateFilterButtons.length && $consultantsByState.length) {
			let timeOutLength = 0
			$stateFilterButtons.on('click', function() {
				const $stateButton = $(this),
					stateTargetId = $stateButton.data('stateValue'),
					stateTargetIdName = `js-${stateTargetId}-consultants`,
					$targetStatePanelElement = $(`#${stateTargetIdName}`)
				
				$stateDropdownTrigger.trigger('click').text($stateButton.text())
				$consultantsByState.each((id, el) => {
					const $stateElement = $(el)
					if ($stateElement.attr('id') != stateTargetIdName) {
						$stateElement
						.css('opacity', 1)
						.animate(
							{ opacity: 0 },
							{
								queue: false,
								duration: 500,
								complete(){
									$stateElement.css('display', 'none')
								}
							},
						)
						.removeClass('active')
					}
				})

				if ($targetStatePanelElement.hasClass('active') == false) {
						setTimeout(()=>{
							timeOutLength = 500
							$targetStatePanelElement
								.css({'opacity': 0, "display": "block"})
								.animate(
									{ opacity: 1 },
									{
										queue: false,
										duration: 500,
									},
								)
								.addClass('active')
						}, timeOutLength) // trigger this only after the previously active state is faded out
					}
			})
		}
	}

	const $bookAChatTrigger = $('#js-book-a-chat-trigger'),
		$findAConsultantTrigger = $('#js-find-a-consultant-trigger')
	if ($bookAChatTrigger.length) {
		$bookAChatTrigger.on('click', () => {
			const $bookAChatTab = $('#tabPanelTwo-label')
			$bookAChatTab.trigger('click')
			$contactTabs.fadeIn(300, function() {
				$bookAChatTab[0].scrollIntoView({behavior: 'smooth',})
			})
		})
	}
	if ($findAConsultantTrigger.length) {
		$findAConsultantTrigger.on('click', () => {
			const $findAConsultantTab = $('#tabPanelThree-label')
			$findAConsultantTab.trigger('click')
			$contactTabs.fadeIn(300, function() {
				$findAConsultantTab[0].scrollIntoView({behavior: 'smooth',})
			})
		})
	}
})
